import {remCalc} from '_themeUtils'

const tag = {
    Tag: {
        baseStyle: ({colorScheme}: {colorScheme: 'light' | 'dark'}) => ({
            container: {
                bg: colorScheme === 'light' ? 'color.background.white' : 'color.background.black',
                minWidth: 'unset',
                minHeight: 'unset',
            },
            label: {
                color: colorScheme === 'light' ? 'color.text.black' : 'color.text.white',
            },
        }),
        sizes: {
            sm: {
                container: {
                    py: remCalc(2),
                    paddingInline: remCalc(6),
                    paddingInlineEnd: remCalc(6),
                    paddingInlineStart: remCalc(6),
                },
                label: {
                    textStyle: 'paragraphXxs',
                    fontWeight: 400,
                },
            },
            md: {
                container: {
                    py: remCalc(4),
                    paddingInline: remCalc(8),
                    paddingInlineEnd: remCalc(8),
                    paddingInlineStart: remCalc(8),
                },
                label: {
                    textStyle: 'tagMd',
                    fontWeight: 500,
                },
            },
        },
        variants: {
            opacity: ({colorScheme}: {colorScheme: 'light' | 'dark'}) => ({
                container: {
                    bg: colorScheme === 'light' ? 'color.background.alpha.light.70' : 'color.background.alpha.dark.70',
                },
                label: {
                    color: colorScheme === 'light' ? 'color.background.alpha.dark.70' : 'color.background.alpha.light.70',
                    letterSpacing: {base: remCalc(1.2), lg: remCalc(2.4)}, // 15% On figma
                },
            }),
        },
    },
}

export default tag
